import { useCallback } from 'react';

function $scrollTo(element: Element | null, options: ScrollIntoViewOptions = {}) {
    element?.scrollIntoView({ behavior: 'smooth', block: 'start', ...options });
}

export function useScrollCallback({
    className = '',
    id = '',
    options,
    timeout = 300,
    shouldGetParentElement = false,
}: {
    id?: string;
    className?: string;
    timeout?: number;
    options?: ScrollIntoViewOptions;
    shouldGetParentElement?: boolean;
} = {}) {
    const runScroll = useCallback(() => {
        if (!className && !id) {
            return;
        }

        setTimeout(() => {
            try {
                let element = className
                    ? document.getElementsByClassName(className)[0]
                    : document.getElementById(id);

                if (shouldGetParentElement) {
                    element = element?.parentElement ?? null;
                }

                $scrollTo(element, options);
            } catch {
                /* ignored */
            }
        }, timeout);
    }, [className, id, options, timeout, shouldGetParentElement]);

    return runScroll;
}
